import React from "react";
import kebabCase from "lodash/kebabCase";
import Link from "gatsby-link";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import fasMicrophone from "@fortawesome/fontawesome-free-solid/faMicrophone";
import fasTrophy from "@fortawesome/fontawesome-free-solid/faTrophy";
import fasUserCircle from "@fortawesome/fontawesome-free-solid/faUserCircle";
import fasMusic from "@fortawesome/fontawesome-free-solid/faMusic";
import fasVideo from "@fortawesome/fontawesome-free-solid/faVideo";
import fasStar from "@fortawesome/fontawesome-free-solid/faStar";

const TAGS = {
  "award show": fasTrophy,
  "radio": fasMicrophone,
  "interview": fasUserCircle,
  "music show": fasMusic,
  "cf": fasVideo,
  "variety": fasStar,
};

function getIcon(tag) {
  console.log(tag);

  if (!(tag.toLowerCase() in TAGS)) {
    return null;
  }


  return TAGS[tag.toLowerCase()];
}

export default class extends React.Component {
  render() {
    const {tags} = this.props;
    return (
      <div className="columns is-centered">
        <div className="column is-two-thirds">
          <div className="columns is-multiline is-mobile">
            {
              tags.map(tag => (
                <div key={tag.fieldValue} className="column is-one-third has-text-centered">
                  <div className="box">
                    <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                      <p>
                        <span className="icon icon is-large">
                          <FontAwesomeIcon icon={getIcon(tag.fieldValue)} size="3x" />
                        </span>
                      </p>
                      <p>
                        {`${tag.fieldValue} (${tag.totalCount})`}
                      </p>
                    </Link>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoTypes/VideoTypes.jsx